import React from "react";
import styles from "./fba-listings-page-steps.module.css";
import { useFbaListingContext } from "@/contexts/FbaListingContext";
import IconLock from "@/components/icons/IconLock";
import Flex from "@/components/Flex/Flex";

const steps = [ "Create FBA Listings", "Review FBA Listings" ];

type FbaListingsPageStepsProps = {};

const FbaListingsPageSteps = ({}: FbaListingsPageStepsProps) => {
  const { fbaListingFlowStep } = useFbaListingContext();

  return (
    <Flex>
      {steps.map((step, index) => (
        <div
          key={index}
          className={`
            ${styles.stepItem}
            ${index === (fbaListingFlowStep) ? styles.stepItemActive : ""}
            ${index < (fbaListingFlowStep) ? styles.stepItemPassed : ""}
            ${index < (fbaListingFlowStep) ? styles.stepItemLocked : ""}
          `}
        >
          {index < (fbaListingFlowStep) && (
            <div className={styles.stepNumber}>
              <IconLock size={20} />
            </div>
          )}
          {index >= (fbaListingFlowStep) && (
            <div className={styles.stepNumber}>
              <span className="strong">{index + 1}</span>
            </div>
          )}
          <span className={`strong ${styles.stepLabel}`}>{step}</span>
        </div>
      ))}
    </Flex>
  );
};

export default FbaListingsPageSteps;